import {
  Alert,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from "@mui/material";
import { DateTimeField } from "../../../../../core/ui/components/DateTimeField";

const NewRoundDialog = ({ open, seasonName, status, errorMessage, endsAt, onEndsAtChange, onClose, onConfirm }) => (
  <Dialog open={open} onClose={status === "loading" ? undefined : onClose} fullWidth maxWidth="sm">
    <DialogTitle>Nova rodada</DialogTitle>
    <DialogContent>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Temporada: <strong>{seasonName || "-"}</strong>
      </Typography>

      {!status && (
        <Stack spacing={2}>
          <DateTimeField
            label="Data final da rodada"
            value={endsAt}
            onChange={onEndsAtChange}
            minDateTime={new Date().toISOString()}
          />
          <Alert severity="warning">
            Ao criar uma nova rodada, as rodadas ativas serão encerradas
            automaticamente. Deseja continuar?
          </Alert>
        </Stack>
      )}

      {status === "loading" && (
        <Stack direction="row" spacing={1.5} alignItems="center">
          <CircularProgress size={20} />
          <Typography variant="body2">Criando rodada...</Typography>
        </Stack>
      )}

      {status === "error" && (
        <Alert severity="error">
          {errorMessage || "Houve um erro ao criar a rodada. Tente novamente."}
        </Alert>
      )}

      {status === "success" && (
        <Alert severity="success">
          Rodada iniciada com sucesso!
        </Alert>
      )}
    </DialogContent>
    <DialogActions>
      {(status === "error" || status === "success") ? (
        <Button onClick={onClose}>Fechar</Button>
      ) : (
        <>
          <Button onClick={onClose} disabled={status === "loading"}>
            Cancelar
          </Button>
          <Button
            variant="contained"
            onClick={onConfirm}
            disabled={status === "loading" || !endsAt}
          >
            Confirmar
          </Button>
        </>
      )}
    </DialogActions>
  </Dialog>
);

export default NewRoundDialog;
